<script>
    import { createEventDispatcher } from 'svelte'
    import { draggable } from '@neodrag/svelte'

    import { backlog } from '../../stores'

    import { intersectRect } from '@/helpers'

    export let data = {
        title: '',
        style: 'orange'
    }
    export let disabled = false
    export let dayMode = false

    const dispatch = createEventDispatcher()

    const { id, title, style } = data;

    const handleDragEnd = (e) => {
        const activeDropNode = document.querySelector('.day-drop-active')
        const activeDropNodeDomRect = activeDropNode.getBoundingClientRect();
        const isIntersect = intersectRect(e.domRect, activeDropNodeDomRect)
        if (isIntersect){
            dispatch('addtoday', data)
            backlog.update((state) => state.filter((a) => a !== id))
            ym(88256496,'reachGoal','game_drag_done')
        } else {
            const originalState = [...$backlog]
            backlog.update((state) => state.filter((a) => a !== id))
            setTimeout(() => backlog.set(originalState), 0)
        }
    }
</script>

<div 
    use:draggable={{
        disabled: disabled || dayMode,
        bounds: document.querySelector('.game-inner'), 
        onDragEnd: handleDragEnd 
    }}
    class="action-wrapper {style}"
    class:blue={style === 'blue'}
    class:purple={style === 'purple'}
    class:orange={style === 'orange'}
    class:disabled
    class:daymode={dayMode}
>
    {title}
</div>

<style lang="scss" module>
    .action-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: calc((((100% + 30px) - (4 * 20px) - (2 * 41px)) / 5) - (2 * 11px));
        height: 107px;
        font-size: 16px;
        line-height: 20px;
        color: #FFFFFF;
        text-align: center;
        border-radius: 7px;
        padding: 0 15px;
        margin-right: 15px;
        margin-bottom: 15px;
        cursor: grab;

        &.blue {
            background-color: rgba(74, 142, 243, 0.8);
            box-shadow: 0px 4px 9px rgba(74, 142, 243, 0.25);
        }

        &.purple {
            background-color: rgba(164, 97, 205, 0.8);
            box-shadow: 0px 4px 9px rgba(126, 59, 167, 0.25);
        }

        &.orange {
            background-color: rgba(255, 113, 0, 0.76);
            box-shadow: 0px 4px 9px rgba(243, 149, 74, 0.25);
        }

        &.disabled {
            background: #D1D1D1;
            box-shadow: 0px 4px 9px rgba(100, 100, 100, 0.3);
            cursor: initial;
        }

        &.daymode {
            width: 100%;
            margin-right: 0;
            cursor: initial;
        }
    }

    @media (max-width: 1120px) {
        .action-wrapper {
            font-size: 12px;
            line-height: 15px;
            width: calc((100% / 6) - 25px);
            height: 75px;
            padding: 0 5px;
            margin-bottom: 12px;
        }
    }

    @media (max-width: 940px) {
        .action-wrapper {
            width: calc((100% / 5) - 20px);
        }
    }

    @media (max-width: 720px) {
        .action-wrapper {
            width: calc((100% / 2) - 5px);
            font-size: 12px;
            line-height: 15px;
            padding: 0 6px;
            height: 69px;
            margin-right: 0;
            margin-bottom: 12px;
        }
    }
</style>